import React, { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Header } from '../Header';
import { Footer } from '../Footer';

const MainLayout = ({ children }) => {
    const location = useLocation();

    useLayoutEffect(() => {
        if ('scrollBehavior' in document.documentElement.style) {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        } else {
            document.documentElement.scrollTop = 0;
            document.body.scrollTop = 0;
        }
    }, [location.pathname]);


    return (
        <>
            <div>
                <Header />
                <main className="">
                    {children}
                </main>
                <Footer />
            </div>

        </>

    )
}

export default MainLayout